import { ActivatedRoute, Router } from "@angular/router";
import { ToastyService } from "ng2-toasty";
import { CourseService } from "../../Services/course.service";
import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import Swal from 'sweetalert2';
import { UploadService } from "../../Services/upload.service";


@Component({
  selector: "app-course-form",
  template: require('./course-form.component.html'),
  styles: [require('./course-form.component.css')]
})
export class CourseFormComponent implements OnInit {
  course: any = {};
  file: File;
  refreshFile: boolean = false;
  courseFileInformation: string = "geen informatie";
  categories: any[] = [];

  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastyService: ToastyService,
    private courseService: CourseService,
    private uploadService: UploadService,
    private datePipe: DatePipe
  ) {
    route.params.subscribe(p => {
      if (p["id"]) this.course.id = +p["id"];
      else this.course.id = 0;
    });
  }

  ngOnInit() {
    if (this.course.id > 0) {
      this.courseService.getCourse(this.course.id).subscribe(
        g => {
          this.course = g;
          this.getCourseFileInformation()
          // console.log(this.course);
        },
        err => {
          console.log(err);
          console.log(this.course.id);
        }
      );
    }
    this.courseService.getCourseCategories().subscribe( x =>{
      this.categories = x;
      // console.log(x);
    });
  }

  submit(reroute: boolean = true) {
    if (this.course.id) {
      this.courseService.update(this.course).subscribe(x => {
        // console.log("save of course: " + x);
        // this.doUploadOfFile(x.id, this.file);
        if (reroute)
          this.router.navigate(["/courses/list"]);
      });
    } else {
      this.courseService.create(this.course).subscribe(x => {
        // console.log("na create: " + JSON.stringify(x));
        // console.log(x.id)
        // this.doUploadOfFile(x.id, this.file);
        if (reroute)
          this.router.navigate(["/courses/list"]);
      });
    }
  }

  delete() {
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze track wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.courseService.delete(this.course.id).subscribe(x => {
          this.router.navigate(["/courses/list"]);
        });
      }
    });
  }

  // private doUploadOfFile(id: number, f: File) {
  //   if (f != null) {
  //     this.courseService.uploadFile(id, f).subscribe((x: any) => {
  //       console.log("Upload of File:" + x);
  //     });
  //   }
  // }

  uploadCourseFile() {
    var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        this.file = files[0];
        this.course.fileName = this.file.name;
      }
    }
  }

  RefreshTrack(id: number) {
    this.refreshFile = true;
    // console.log("id:" + id);
    this.courseService.reloadTrack(id).subscribe(x => {
      this.course = x.value;
      this.refreshFile = false;
      this.getCourseFileInformation();
    })
  }

  ReverseTrack(id: number){
     Swal.fire({
                title: 'Ben je zeker?',
                text: "Ben je zeker dat je deze track wil omkeren?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Jep',
                cancelButtonText: 'Nope'
              }).then((result) => {
                if (result.value) {
                 this.courseService.reverseTrack(id).subscribe( x =>{
                    if (x.status == 200){
                         Swal.fire({
                            title: 'Gelukt',
                            text: "De track is omgekeerd",
                            type: 'success',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Jep',
                          })
                    }else{
                      Swal.fire({
                            title: 'Probleem',
                            text: "De track is niet omgekeerd, er was een probleem",
                            type: 'error',
                            confirmButtonColor: '#d63030',
                            confirmButtonText: 'Ok',
                          })
                    }
                    
                  })
                }
              });
    
    
  }

  isLoading() {
    return this.refreshFile
  }

  private getCourseFileInformation() {
    if (this.course.fileName) {
      this.courseFileInformation = this.course.fileName + " @ " + this.datePipe.transform(this.course.fileLastUpdate, "dd-MM-y HH:mm");
    }
  }

  // uploadGpx() {
  //   var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
  //   if (nativeElement != null) {
  //     var files = nativeElement.files;
  //     if (files != null) {
  //       var file = files[0];
  //       // console.log("Upload file: ")
  //       // console.log(file.name);
  //       this.uploadService.uploadCourseFile(file).subscribe(x => {
  //         this.course.fileName = x.filename;
  //       })
  //     }
  //   }
  // }

  showUploadDialog(){
    Swal.fire({
      input: 'file',
      inputAttributes: {
          name:"upload[]",
          id:"fileToUpload",
          accept: ".gpx",         
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Never mind'
  }).then( (result)=>{
      if (result.value){
        this.uploadService.uploadCourseFile(result.value).subscribe(x => {
          this.course.fileName = x.filename;
          this.submit(false);
          this.RefreshTrack(this.course.id);
        })
      }
    })
  }

  // uploadCourseFile() {
  //   console.log("Upload File");
  //   var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
  //   console.log(nativeElement);
  //   if (nativeElement != null) {
  //     console.log("second if");
  //     var files = nativeElement.files;
  //     console.log(files);
  //     if (files != null) {
  //       console.log("inner if");
  //       this.courseService.uploadFile(this.course.id, files[0]).subscribe(x => {
  //         console.log(x);
  //       });
  //     }
  //   }
  // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/course-form/course-form.component.ts